import { useState } from "react"

import { adminApi } from "../axios"
import { formatAdminLoadError } from "./useAdminPaginatedQuery"

function formatMailboxError(error) {
  const data = error?.response?.data
  if (typeof data?.detail === "string") return data.detail
  if (typeof data?.owner_user_id === "string") return data.owner_user_id
  if (Array.isArray(data?.non_field_errors)) {
    return data.non_field_errors.join(" ")
  }
  if (typeof data?.owner_user_id === "object" && data.owner_user_id?.[0]) {
    return data.owner_user_id[0]
  }
  return formatAdminLoadError(error, "Could not update Zoho mailbox.")
}

export function useAdminZohoMailboxMutations(onSuccess) {
  const [editRow, setEditRow] = useState(null)
  const [deleteRow, setDeleteRow] = useState(null)
  const [saving, setSaving] = useState(false)
  const [dialogError, setDialogError] = useState(null)

  async function handleSaveEdit(payload) {
    if (!editRow) return
    setSaving(true)
    setDialogError(null)
    try {
      await adminApi.updateMailbox(editRow.id, payload)
      setEditRow(null)
      onSuccess?.()
    } catch (error) {
      setDialogError(formatMailboxError(error))
    } finally {
      setSaving(false)
    }
  }

  async function handleConfirmDelete() {
    if (!deleteRow) return
    setSaving(true)
    setDialogError(null)
    try {
      await adminApi.deleteMailbox(deleteRow.id)
      setDeleteRow(null)
      onSuccess?.()
    } catch (error) {
      setDialogError(formatMailboxError(error))
    } finally {
      setSaving(false)
    }
  }

  function closeDialogs() {
    setEditRow(null)
    setDeleteRow(null)
    setDialogError(null)
  }

  return {
    editRow,
    setEditRow,
    deleteRow,
    setDeleteRow,
    saving,
    dialogError,
    handleSaveEdit,
    handleConfirmDelete,
    closeDialogs,
  }
}
